import React from "react";
import { Button, Form } from "react-bootstrap";
import { PersonCircle } from "react-bootstrap-icons";

function DispositionScreen({
  dispositionMeta,
  dispositionValues,
  setDispositionValues,
  dispositionErrors,
  setDispositionErrors,
  remarkStatusList,
  dispositionSubmitting,
  userData,
  onSubmit,
  onBack,
}) {
  const fields = dispositionMeta?.fields || [];
  const profiles = userData?.agentData?.agentTelephony?.profile || [];

  const activeTelephonyProfile = profiles.find(
    (p) =>
      (p?.type === "WEBRTC" || p?.type === "Soft Phone") &&
      p?.active_profile === true,
  );

  const extension =
    activeTelephonyProfile?.number?.number ||
    profiles.find((p) => p?.type === "WEBRTC")?.number?.number ||
    profiles.find((p) => p?.type === "Soft Phone")?.number?.number ||
    null;

  const infoRows = [
    { k: "Username", v: userData?.username || userData?.email || "-" },
    // { k: "Email", v: userData?.email || "-" },
    { k: "Parent", v: userData?.createdByUser?.username || "-" },
    { k: "Agent Name", v: userData?.agentData?.agent_name || "-" },
    { k: "Agent Number", v: userData?.agentData?.agent_number || "-" },
    // { k: "Agent Description", v: userData?.agentData?.description || "-" },
    { k: "Agent Access", v: userData?.agentData?.access || "-" },
    { k: "Extension", v: extension || "-" },
  ];

  const campaignRows = [
    { k: "Disposition Form", v: dispositionMeta?.dispositionForm?.name || "-" },
    { k: "Campaign ID", v: dispositionMeta?.campaign_id || "-" },
    { k: "Agent ID", v: dispositionMeta?.agent_id || "-" },
    { k: "Campaign Name", v: dispositionMeta?.campaign_name || "-" },
    { k: "Caller Number", v: dispositionMeta?.callerNumber || "-" },
    { k: "Call SID", v: dispositionMeta?.call_sid || "-" },
  ];

  const clearFieldError = (name) => {
    if (!name) return;
    if (!dispositionErrors?.[name]) return;
    setDispositionErrors((prev) => {
      const next = { ...(prev || {}) };
      delete next[name];
      return next;
    });
  };

  return (
    <div className="screen active">
      <div className="disposition-layout">
        <div className="stack-col">
          <div className="panel">
            <div className="panel-header">
              <div className="panel-title">Agent & User</div>
            </div>
            <div className="panel-body">
              <div className="cti-disposition-avatar">
                <PersonCircle size={92} />
              </div>
              <div className="cti-disposition-info-list">
                {infoRows.map((row) => (
                  <div className="cti-disposition-info-row" key={row.k}>
                    <div className="cti-disposition-info-key">{row.k}</div>
                    <div className="cti-disposition-info-val">{row.v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="panel" style={{ height: "375px", overflowY: "scroll" }}>
          <div className="panel-header cti-disposition-form-header">
            <div className="cti-disposition-form-title">
              <div className="panel-title">
                Disposition Form -{" "}
                <strong style={{ fontSize: "17px" }}>
                  {dispositionMeta?.dispositionForm?.name || "Disposition"}
                </strong>
              </div>
            </div>
            <div className="cti-disposition-actions">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={onBack}
                style={{ backgroundColor: "rgb(229, 23, 44)", color: "white" }}
              >
                Back
              </Button>
              <Button
                // variant="primary"
                size="sm"
                onClick={onSubmit}
                disabled={dispositionSubmitting || !dispositionMeta}
                style={{ backgroundColor: "rgb(0, 137, 37)", color: "white" }}
              >
                {dispositionSubmitting ? "Saving..." : "Submit"}
              </Button>
            </div>
          </div>

          {!dispositionMeta ? (
            <div
              className="panel-title"
              style={{
                padding: "10px",
                paddingTop: "50px",
                fontSize: "18px",
                textAlign: "center",
              }}
            >
              No disposition pending.
            </div>
          ) : (
            <>
              <div className="panel-body">
                <div className="cti-disposition-form-grid">
                  {!fields.length && (
                    <>
                      <Form.Group>
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          value={dispositionValues?.first_name || ""}
                          onChange={(e) =>
                            setDispositionValues((prev) => ({
                              ...prev,
                              first_name: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                          value={dispositionValues?.last_name || ""}
                          onChange={(e) =>
                            setDispositionValues((prev) => ({
                              ...prev,
                              last_name: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                          value={dispositionValues?.contact_number || ""}
                          onChange={(e) =>
                            setDispositionValues((prev) => ({
                              ...prev,
                              contact_number: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Label>
                          Remarks Status <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          as="select"
                          multiple
                          value={dispositionValues?.remarks_status || []}
                          onChange={(e) => {
                            const options = Array.from(
                              e.target.selectedOptions,
                              (o) => o.value,
                            );
                            setDispositionValues((prev) => ({
                              ...prev,
                              remarks_status: options,
                            }));
                            clearFieldError("remarks_status");
                          }}
                        >
                          {remarkStatusList.map((item) => (
                            <option key={item.id} value={item.remark}>
                              {item.remark}
                            </option>
                          ))}
                        </Form.Control>

                        {dispositionErrors?.remarks_status && (
                          <small style={{ color: "red" }}>
                            {dispositionErrors.remarks_status}
                          </small>
                        )}
                      </Form.Group>
                    </>
                  )}

                  {fields.map((field) => {
                    const name = String(field?.field_name || "").trim();
                    if (!name) return null;

                    const type = field?.field_type || "String";
                    const required = Boolean(field?.is_required);
                    const error = dispositionErrors?.[name];

                    const options = Array.isArray(field?.options)
                      ? field.options
                      : [];

                    const value = dispositionValues?.[name];
                    const inputType =
                      type === "Integer" || type === "Float"
                      ? "number"
                      : type === "Date"
                      ? "date"
                      : "text";

                    const step =
                      type === "Integer"
                      ? 1
                      : type === "Float"
                      ? "any"
                      : undefined;

                    const min =
                      typeof field?.field_min === "number"
                      ? field.field_min
                      : undefined;

                    const max =
                      typeof field?.field_max === "number"
                      ? field.field_max
                      : undefined;

                    return (
                      <Form.Group key={name}>
                        <Form.Label>
                          {name}
                          {required && (
                            <span style={{ color: "red", marginLeft: 4 }}>
                              *
                            </span>
                          )}
                        </Form.Label>
                        {type === "Boolean" ? (
                          <Form.Check
                            type="checkbox"
                            checked={Boolean(value)}
                            label="Yes"
                            onChange={(e)=>{
                              setDispositionValues((prev)=>({
                                ...(prev||{}),
                                [name]:e.target.checked
                              }));
                              clearFieldError(name);
                            }}
                          />
                        ) : type === "Multi Select" ? (
                          <Form.Control
                            as="select"
                            multiple
                            value={
                              Array.isArray(value)
                              ? value
                              : typeof value === "string"
                              ? value.split(",").map(v => v.trim())
                              : []
                            }
                            onChange={(e) => {
                              const values = Array.from(
                                e.target.selectedOptions,
                                (o) => o.value.trim()
                              );
                              setDispositionValues((prev) => ({
                                ...(prev || {}),
                                [name]: values
                              }));
                              clearFieldError(name);
                            }}
                          >
                            {options.map((opt)=>(
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </Form.Control>
                        ) : (
                          <Form.Control
                            type={inputType}
                            step={step}
                            min={min}
                            max={max}
                            value={value ?? ""}
                            onChange={(e)=>{
                              setDispositionValues((prev)=>({
                                ...(prev||{}),
                                [name]:e.target.value
                              }));
                              clearFieldError(name);
                            }}
                          />
                        )}
                        {error && (
                          <small
                            style={{
                              color: "red",
                              display: "block",
                              marginTop: 4,
                            }}
                          >
                            {error}
                          </small>
                        )}
                      </Form.Group>
                    );
                  })}
                </div>
                <div style={{ marginTop: "30px" }}>
                  <div className="panel-header">
                    <div className="panel-title">Campaign</div>
                  </div>
                  <div className="panel-body">
                    <div className="cti-disposition-info-list">
                      {campaignRows.map((row) => (
                        <div className="cti-disposition-info-row" key={row.k}>
                          <div className="cti-disposition-info-key">
                            {row.k}
                          </div>
                          <div className="cti-disposition-info-val">
                            {row.v}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(DispositionScreen);
